import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types';
import { ShapeCreator, Icons, Util } from '@leverege/api-attributes';
import { Button, Text, ToggleButton } from '@leverege/ui-elements'
import style from './style.css'
import { ValueCard } from '~/views';
import { JsonEditorDialog } from '../views'

import S from './style.css' 

export default class ShapeViewer extends React.Component {

  static TYPE = ShapeCreator.typeName();

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    name : PropTypes.string
  }

  constructor( props, context ) {
    super( props, context )
    this.state = {}
  }

  onOk = ( val ) => {
    const { onSetValue, onChange, attribute, cxt } = this.props
    this.setState( {
      show : false
    } )
    if ( onSetValue ) {
      const ids = Util.getPathIds( attribute.path )
      const colls = Util.getPathCollections( attribute.path )
      const resPath = Util.getResolvedPath( attribute.path, cxt || {}, ids, colls )
      onSetValue( { attribute : { ...attribute, path : resPath }, value : JSON.stringify( val ), path : attribute.path, cxt } )
    } else if ( onChange ) {
      onChange( { attribute, value : JSON.stringify( val ) } )
    }
    
  }

  onCancel = () => {
    this.setState( {
      show : false
    } )
  }

  onOpen = () => {
    this.setState( {
      show : true
    } )
  }

  render() {
    const { attribute : attr, name, value, className } = this.props
    console.log( this.props )
    
    const { show } = this.state
    if ( attr == null ) {
      return <div />
    }

    let val = {}, valid = true
    if ( typeof value === 'object' ) {
      val = value
    } else if ( typeof value === 'string' ) {
      try { 
        val = JSON.parse( value )
      } catch ( e ) {
        console.log( 'Shape is not valus JSON string', e )
        val = false
      }
    } else if ( value != null ) {
      valid = false
    }
    const vName = ( val == null ? 
      <span className={S.noValue}>not set</span> :
      <span className={S.value}>Edit</span> )
    
    return (
      <div>
        <ToggleButton value={show} onChange={() => { this.setState( { show : true } ) }}>{vName}</ToggleButton>
        <JsonEditorDialog
          show={show}
          onOk={this.onOk}
          onCancel={this.onCancel}
          title="Shape Editor"
          message="Edit Shape"
          value={val}
          ok="Update Shape"
          cancel="Cancel Changes" />
      </div>
    )

    // return (
    //   <div className={classnames( style.ShapeEditor, className )}>
    //     <Text>{name}</Text>
    //     <InsetSection>
    //       <div className={ ( value && valid ) ? style.Shape : style.noShape}>{( value && valid && JSON.stringify( val ) ) || 'Empty Shape' }</div> 
    //       <Button variant="link" onClick={() => { this.setState( { show : true } ) }}>Edit</Button>
    //     </InsetSection>
    //     <JsonEditorDialog
    //       show={show}
    //       onOk={this.onOk}
    //       onCancel={this.onCancel}
    //       title="Shape Editor"
    //       message="Edit Shape"
    //       value={val}
    //       ok="Update Shape"
    //       cancel="Cancel Changes" />
    //   </div>
    // )
  }
}
